let APP_ENV = process.env.REACT_APP_ENV || "dev";
let API_SERVER = process.env.REACT_APP_API_HOST ? process.env.REACT_APP_API_HOST + "/api": "http://localhost:8000/api";

export {
    APP_ENV,
    API_SERVER
}